/**
 * The zoom buttons: minus, the current span, plus, and a way back to now.
 *
 * + and - walk the fixed ladder from wherever a pinch left the span
 * (`nextZoomSpan`), and each is disabled at its end of the ladder rather than
 * doing nothing when pressed. "To now" shows only while the chart is scrolled
 * away from the newest check, and sits left of the group so appearing does
 * not move the buttons the reader is about to press again.
 */
import { ChevronsRight, Minus, Plus } from "lucide-react";
import { IconBtn } from "../../../ui";
import type { T } from "../words";
import { spanText } from "./labels";

export function ZoomControls({
  span,
  pinned,
  canZoomIn,
  canZoomOut,
  onZoomIn,
  onZoomOut,
  onNow,
  t,
}: {
  span: number;
  pinned: boolean;
  canZoomIn: boolean;
  canZoomOut: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onNow: () => void;
  t: T;
}) {
  const label = spanText(t, span);
  return (
    <div className="crm-push flex items-center gap-1.5">
      {!pinned ? (
        <IconBtn small aria-label={t("monitoring.chart.toNow")} title={t("monitoring.chart.toNow")} onClick={onNow} className="mr-1">
          <ChevronsRight className="size-4" strokeWidth={1.8} />
        </IconBtn>
      ) : null}
      <IconBtn small aria-label={t("monitoring.chart.zoomOut")} title={t("monitoring.chart.zoomOut")} disabled={!canZoomOut} onClick={onZoomOut}>
        <Minus className="size-4" strokeWidth={1.8} />
      </IconBtn>
      <span
        className="crm-tnum min-w-[4.5rem] text-center text-[12.5px] font-semibold"
        aria-live="polite"
        title={t("monitoring.chart.span", { span: label })}
      >
        {label}
      </span>
      <IconBtn small aria-label={t("monitoring.chart.zoomIn")} title={t("monitoring.chart.zoomIn")} disabled={!canZoomIn} onClick={onZoomIn}>
        <Plus className="size-4" strokeWidth={1.8} />
      </IconBtn>
    </div>
  );
}
